export const Featured = () => {
  return (
    <>
      Featured
    </>
  )
}